import { cloneDeep } from 'lodash';
const SET_ACTIVE_PRODUCT = 'SET_ACTIVE_PRODUCT';

const initialState = {};

export default function reducer(state = cloneDeep(initialState), action) {
	switch (action.type) {
		case SET_ACTIVE_PRODUCT:
			return {...action.payload};
		default:
			return state;
	}
}

export function setActiveProduct(product){
	return{
		type: SET_ACTIVE_PRODUCT,
		payload: product
	}
}

export function initializeActiveProduct(){
	let oActiveProduct = {};
	return (dispatch, getState) => {
	  if (getState().activeFilter === 'product') oActiveProduct = getState().activeFilterResult;
		return dispatch( setActiveProduct(oActiveProduct) );
	}
}

export function updateActiveProduct(){
	let oActiveProduct = {};
	return (dispatch, getState) => {
		if (getState().activeFilter === 'product') oActiveProduct = getState().activeFilterResult;
		return dispatch( setActiveProduct(oActiveProduct) );
	}
}


// WEBPACK FOOTER //
// ./src/modules/active_product.js